import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowRight } from "react-icons/ai";

import MessageDialog from "components/__reusable/MessageDialog";
import DialogActionButton from "components/__reusable/DialogActionButton";
import useAppSelector from "hooks/useAppSelector";
import useAppDispatch from "hooks/useAppDispatch";
import { resetSuccessStatus } from "features/success/successSlice";
import Desktop from "assets/images/desktop.png";
import Mobile from "assets/images/mobile.png";
import { UNPUBLISHED_PICTURES_PATH } from "router/pathName";

const SuccessMessageDialog = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    success,
    title,
    message,
    isPublished,
    isStudentCreated,
    showViewScreenAction,
    onClose,
  } = useAppSelector((state) => state.success);

  const close = () => {
    onClose && onClose();
    dispatch(resetSuccessStatus());
  };

  const renderStudentCreatedActionButtons = () => {
    return (
      <div className="grid w-full grid-cols-2 gap-4">
        <DialogActionButton
          label={t("_student_form._return_to_student_list")}
          onClick={() => {
            close();
            const classId = window.location.pathname.split("/")[2];
            navigate(`/class/${classId}/student`);
          }}
          variant="secondary"
        />
        <DialogActionButton
          label={t("_student_form._goto_registration")}
          onClick={() => {
            close();
            const classId = window.location.pathname.split("/")[2];
            window.location.href = `/class/${classId}/student/new`;
          }}
          variant="primary"
        />
      </div>
    );
  };

  const renderViewScreenActionButtons = () => {
    return (
      <div className="grid w-full grid-cols-2 gap-4">
        <DialogActionButton
          label={t("_generic._close")}
          onClick={() => close()}
          variant="secondary"
        />
        <DialogActionButton
          label={t("_upload._goto_view_screen")}
          onClick={() => {
            close();
            navigate(UNPUBLISHED_PICTURES_PATH);
          }}
          rightIcon={<AiOutlineArrowRight size={20} color="#fff" />}
          variant="primary"
        />
      </div>
    );
  };

  const renderActionButtons = () => {
    return (
      <div className="w-full max-w-[180px]">
        <DialogActionButton
          label={t("_generic._close")}
          onClick={() => close()}
          variant="primary"
        />
      </div>
    );
  };

  return success ? (
    <MessageDialog>
      <div className="mx-auto flex max-w-4xl flex-col items-center justify-center space-y-6 text-center">
        <h2 className="text-[28px] font-semibold leading-tight text-[#333333]">
          {t(title)}
        </h2>
        <p className="whitespace-pre-wrap text-sm leading-7 text-[#333333]">
          {t(message)}
        </p>
        {isPublished && (
          <div className="my-8 w-full">
            <table className="w-full">
              <tbody>
                <tr>
                  <td className="px-2 text-center align-center">
                    <div className="flex flex-col items-center justify-between">
                      <img
                        src={Desktop}
                        alt="Desktop admin panel"
                        className="h-auto w-64 md:w-80"
                      />
                    </div>
                  </td>
                  <td className="w-24 px-2 text-center align-middle">
                    <div className="flex items-center justify-center space-x-0.5">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="gray"
                        style={{ opacity: 0.3 }}
                      >
                        <polygon points="6,4 20,12 6,20" />
                      </svg>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="gray"
                        style={{ opacity: 0.6 }}
                      >
                        <polygon points="6,4 20,12 6,20" />
                      </svg>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="gray"
                        style={{ opacity: 1 }}
                      >
                        <polygon points="6,4 20,12 6,20" />
                      </svg>
                    </div>
                  </td>
                  <td className="h-full px-2 text-center align-top">
                    <div className="flex h-full flex-grow flex-col items-center justify-between">
                      <img
                        src={Mobile}
                        alt="Mobile app notification"
                        className="h-auto w-32 md:w-40"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="px-2 text-center align-top">
                    <div className="mt-2">
                      <span className="text-sm text-gray-600">管理画面</span>
                    </div>
                  </td>
                  <td></td>
                  <td className="px-2 text-center align-top">
                    <div className="mt-2">
                      <span className="text-sm text-gray-600">
                        保護者アプリ
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        {isStudentCreated
          ? renderStudentCreatedActionButtons()
          : showViewScreenAction
          ? renderViewScreenActionButtons()
          : renderActionButtons()}
      </div>
    </MessageDialog>
  ) : (
    <></>
  );
};

export default SuccessMessageDialog;
